import { StripePaymentMethodData } from '@monetize/types/app';
import { Maybe } from '@monetize/types/common';
import {
  PaymentElement,
  useElements,
  useStripe,
} from '@stripe/react-stripe-js';
import {
  Stripe,
  StripeElements,
  StripePaymentElementChangeEvent,
} from '@stripe/stripe-js';
import { useEffect, useState } from 'react';
import { StripePaymentMethodTerms } from '../../../components/Payments/StripePaymentMethodTerms';
import { logger } from '../../../services/logger';
import Sentry from '../../../services/sentry';

interface PaymentMethodSharePaymentMethodProps {
  companyName?: Maybe<string>;
  onInit: (data: {
    stripe?: Maybe<Stripe>;
    elements?: Maybe<StripeElements>;
  }) => void;
  onStripeStateChange: (state: 'LOADING' | 'ERROR' | 'READY') => void;
}

export const PaymentMethodSharePaymentMethod = ({
  companyName,
  onInit,
  onStripeStateChange,
}: PaymentMethodSharePaymentMethodProps) => {
  const elements = useElements();
  const stripe = useStripe();
  const [stripeData, setStripeData] = useState<StripePaymentMethodData>();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => onInit({ stripe, elements }), [stripe, elements]);

  const handlePaymentFormChangeEvent = ({
    complete,
    empty,
    value,
  }: StripePaymentElementChangeEvent) => {
    setStripeData({ empty, complete, type: value.type });
  };

  return (
    <>
      <PaymentElement
        onChange={handlePaymentFormChangeEvent}
        onLoaderStart={() => onStripeStateChange('LOADING')}
        onLoadError={(ev) => {
          onStripeStateChange('ERROR');
          logger.error('onLoadError', ev);
          Sentry.captureException(ev.error, {
            tags: {
              type: 'PAYMENT_METHOD_SHARE',
              action: 'LOAD_PAYMENT_FORM',
            },
          });
        }}
        onReady={(ev) => onStripeStateChange('READY')}
        options={{
          layout: {
            type: 'accordion',
            radios: true,
            defaultCollapsed: false,
            spacedAccordionItems: true,
          },
          terms: {
            usBankAccount: companyName ? 'never' : 'auto',
            card: companyName ? 'never' : 'auto',
          },
          fields: {
            billingDetails: 'auto',
          },
        }}
      />
      {stripeData && companyName && (
        <StripePaymentMethodTerms
          containerProps={{ pt: 3 }}
          companyName={companyName}
          type={stripeData.type}
        />
      )}
    </>
  );
};
